import JobTable from "./view/JobTable";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
const Jobs = () => {
  const viewPermission = PERMISSIONS.permission_utilities_jobconfiguration_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewPermission) && <JobTable />}</>;
};

export default Jobs;
